// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Căn chỉnh caret */
.caret {
  /* margin-right: auto; */
  /* flex-grow: 1;*/
  display: flex;
  width: 100%;
  align-items: center;
  padding-right: 45px;
  position: relative;
  height: 33px;
}

.caret.padding-caret {
  /* margin-right: auto; */
  /* flex-grow: 1;*/
  padding-right: 57px;
}
.caret .text {
  width: 100%;
  white-space: nowrap; /* Ngăn văn bản xuống dòng */
  overflow: hidden; /* Ẩn phần văn bản thừa */
  text-overflow: ellipsis; /* Thêm dấu "..." khi văn bản bị cắt */
}
.button-container {
  white-space: nowrap;
  position: absolute;
  display: flex;
  align-items: center;
  right: 10px;
  height: 33px;
}
.folder-button {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}
.search-button {
  width: 17px;
  height: 16px;
  margin-left: 5px;
}
.folder-button svg,
.search-button svg {
  fill: var(--color-icon-1);
  stroke: var(--color-icon-1);
}
/* Mũi tên */
.arrow-icon {
  margin-right: 10px;
  font-size: 16px;
  transition: 0.1s;
  user-select: none;
}
.arrow-icon svg {
  height: 12px;
  width: 12px;
}
.dpu-tree-item.active .arrow-icon svg {
  fill: #fff;
}
.dpu-tree-item.active .folder-button svg,
.dpu-tree-item.active .search-button svg {
  fill: #fff;
  stroke: #fff;
}
.arrow-icon svg {
  transition: 0.1s;
  fill: var(--color-text-1);
  transform: rotate(-90deg);
}
/*.arrow-icon.arrow-down svg {
     transform: rotate(0deg);  Quay mũi tên khi mở 
  }
  */
/* Placeholder thay thế mũi tên */
.arrow-placeholder {
  width: 12px; /* Kích thước tương tự mũi tên */
  display: inline-block;
  margin-right: 10px;
  flex-shrink: 0;
}

/* Nested items */
.nested {
  display: none;
  padding-left: 10px;
}

.nested.active {
  display: block;
}

/* Khi mở rộng, mũi tên sẽ quay */
.arrow-down {
  transform: rotate(90deg); /* Quay mũi tên 90 độ */
}
.container-treelist {
  font-size: 14px;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  overflow: auto;
  position: relative;
  background-color: var(--background-color-4);
}
.dpu-tree-item {
  cursor: pointer;
  margin: 5px 0;
  display: flex; /* Đảm bảo các phần tử con (text và buttons) nằm ngang */
  justify-content: space-between; /* Đẩy phần tử text và buttonContainer ra hai bên */
  align-items: center; /* Căn giữa các phần tử theo chiều dọc */
  padding: 0px 10px;
  width: 100%;
}

.dpu-tree-item:hover > .fullrow {
  background: var(--primary-color-hover-2);
}

.dpu-tree-item.active > .fullrow {
  background: var(--primary-color-1);
}
.dpu-tree-item.active > .caret {
  color: #fff;
}
.fullrow {
  height: 33px;
  width: 100%;
  position: absolute;
  background: transparent;
  left: 0;
  overflow: hidden;
}

/* Test mới */
.caret--folder {
  width: 10px;
  height: 10px;
  line-height: 10px;
  margin-right: 5px;
}

.dpu-tree-item.active .dpu-load-default-dot {
  background: #fff;
}
.dpu-tree-item .dpu-load-default-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--primary-color-1);
}
`, "",{"version":3,"sources":["webpack://./src/styles/treeTileModel.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB,EAAE,4BAA4B;EACjD,gBAAgB,EAAE,yBAAyB;EAC3C,uBAAuB,EAAE,sCAAsC;AACjE;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;GAGG;AACH,iCAAiC;AACjC;EACE,WAAW,EAAE,gCAAgC;EAC7C,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,wBAAwB,EAAE,uBAAuB;AACnD;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;;EAEV,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,aAAa;EACb,aAAa,EAAE,wDAAwD;EACvE,8BAA8B,EAAE,mDAAmD;EACnF,mBAAmB,EAAE,wCAAwC;EAC7D,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,OAAO;EACP,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":["/* Căn chỉnh caret */\r\n.caret {\r\n  /* margin-right: auto; */\r\n  /* flex-grow: 1;*/\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  padding-right: 45px;\r\n  position: relative;\r\n  height: 33px;\r\n}\r\n\r\n.caret.padding-caret {\r\n  /* margin-right: auto; */\r\n  /* flex-grow: 1;*/\r\n  padding-right: 57px;\r\n}\r\n.caret .text {\r\n  width: 100%;\r\n  white-space: nowrap; /* Ngăn văn bản xuống dòng */\r\n  overflow: hidden; /* Ẩn phần văn bản thừa */\r\n  text-overflow: ellipsis; /* Thêm dấu \"...\" khi văn bản bị cắt */\r\n}\r\n.button-container {\r\n  white-space: nowrap;\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  right: 10px;\r\n  height: 33px;\r\n}\r\n.folder-button {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-left: 5px;\r\n}\r\n.search-button {\r\n  width: 17px;\r\n  height: 16px;\r\n  margin-left: 5px;\r\n}\r\n.folder-button svg,\r\n.search-button svg {\r\n  fill: var(--color-icon-1);\r\n  stroke: var(--color-icon-1);\r\n}\r\n/* Mũi tên */\r\n.arrow-icon {\r\n  margin-right: 10px;\r\n  font-size: 16px;\r\n  transition: 0.1s;\r\n  user-select: none;\r\n}\r\n.arrow-icon svg {\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n.dpu-tree-item.active .arrow-icon svg {\r\n  fill: #fff;\r\n}\r\n.dpu-tree-item.active .folder-button svg,\r\n.dpu-tree-item.active .search-button svg {\r\n  fill: #fff;\r\n  stroke: #fff;\r\n}\r\n.arrow-icon svg {\r\n  transition: 0.1s;\r\n  fill: var(--color-text-1);\r\n  transform: rotate(-90deg);\r\n}\r\n/*.arrow-icon.arrow-down svg {\r\n     transform: rotate(0deg);  Quay mũi tên khi mở \r\n  }\r\n  */\r\n/* Placeholder thay thế mũi tên */\r\n.arrow-placeholder {\r\n  width: 12px; /* Kích thước tương tự mũi tên */\r\n  display: inline-block;\r\n  margin-right: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Nested items */\r\n.nested {\r\n  display: none;\r\n  padding-left: 10px;\r\n}\r\n\r\n.nested.active {\r\n  display: block;\r\n}\r\n\r\n/* Khi mở rộng, mũi tên sẽ quay */\r\n.arrow-down {\r\n  transform: rotate(90deg); /* Quay mũi tên 90 độ */\r\n}\r\n.container-treelist {\r\n  font-size: 14px;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n\r\n  overflow: auto;\r\n  position: relative;\r\n  background-color: var(--background-color-4);\r\n}\r\n.dpu-tree-item {\r\n  cursor: pointer;\r\n  margin: 5px 0;\r\n  display: flex; /* Đảm bảo các phần tử con (text và buttons) nằm ngang */\r\n  justify-content: space-between; /* Đẩy phần tử text và buttonContainer ra hai bên */\r\n  align-items: center; /* Căn giữa các phần tử theo chiều dọc */\r\n  padding: 0px 10px;\r\n  width: 100%;\r\n}\r\n\r\n.dpu-tree-item:hover > .fullrow {\r\n  background: var(--primary-color-hover-2);\r\n}\r\n\r\n.dpu-tree-item.active > .fullrow {\r\n  background: var(--primary-color-1);\r\n}\r\n.dpu-tree-item.active > .caret {\r\n  color: #fff;\r\n}\r\n.fullrow {\r\n  height: 33px;\r\n  width: 100%;\r\n  position: absolute;\r\n  background: transparent;\r\n  left: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Test mới */\r\n.caret--folder {\r\n  width: 10px;\r\n  height: 10px;\r\n  line-height: 10px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.dpu-tree-item.active .dpu-load-default-dot {\r\n  background: #fff;\r\n}\r\n.dpu-tree-item .dpu-load-default-dot {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background-color: var(--primary-color-1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
